import { render, staticRenderFns } from "./CreateLoading.vue?vue&type=template&id=0b7c946e&scoped=true"
import script from "./CreateLoading.vue?vue&type=script&lang=ts"
export * from "./CreateLoading.vue?vue&type=script&lang=ts"
import style0 from "./CreateLoading.vue?vue&type=style&index=0&id=0b7c946e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7c946e",
  null
  
)

export default component.exports